import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  ListBanksHttpAdapter
} from '@features/setting/infrastructure/http/list-banks/list-banks.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  ListBanksUseCasePort
} from '@features/setting/application/use_cases/list-banks/list-banks.use-case.port';

export const ListBanksHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: ListBanksUseCasePort,
    useClass: ListBanksHttpAdapter
  }
];
